import React from "react";
import "../css/paysuccess.css";
import { FiCheck, FiX } from "react-icons/fi";
import { Link, useSearchParams } from "react-router-dom";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get("state") !== "cancel";
  return (
      <main className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className="checkmark-circle">
              {success ? <FiCheck /> : <FiX />}
            </div>
            <p className="success-kicker">{success ? "THANK YOU!" : "PAYMENT CANCELLED"}</p>
            <h1>{success ? "Your payment was successful." : "Your payment was not completed."}</h1>
            <p>{success ? "We have received your order and will send confirmation to the email supplied at checkout." : "No order has been confirmed. Your cart is still available if you would like to try again."}</p>
            <Link to={success ? "/shop" : "/checkout"}>{success ? "Keep exploring" : "Return to checkout"}</Link>
          </div>
        </div>
      </main>
  );
};

export default PaySuccess;
